// extracted by mini-css-extract-plugin
module.exports = {"RV-Tab":"Tab_RV-Tab__4eRuH"};